import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog(props) {
    const {open, setOpen, ok, cancel, title, body, execute, children}= props;

  const handleOkClick = () => {
    setOpen(false);
    if( execute)execute();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title?title:"Confirma operação"}
        </DialogTitle>
        <DialogContent>
          {children && children}
          {!children && 
          <DialogContentText id="alert-dialog-description">
            {body?body:"Confirma para proceguir a operação"}
          </DialogContentText>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" >
              {cancel?cancel:'Cancelar'}
          </Button>
          {ok && 
          <Button color="success" variant="outlined" onClick={handleOkClick} autoFocus>
            {ok?ok:'ok'}
          </Button>}
        </DialogActions>
      </Dialog>
  );
}
